module.exports = "https://static.wanderu.com/static/media/redBus.9c73c979.png";